import { httpClient } from '@/modules/common/services/http/http-client';
import {
  ISendWithdrawSuggested,
  ISendWithdrawSuggestedResponse,
  IWithdrawDetails,
  IWithdrawSummary,
  INetValue
} from './withdraw-by-portfolio-types';

export const http = httpClient.withOptions({
  baseURL: process.env.VUE_APP_BFF_URL
});

export function getWithdrawDetails(
  portfolioId: string
): Promise<IWithdrawDetails> {
  return http.get(
    `/transactions/v1/redemptions/portfolios/${portfolioId}/info`
  );
}

export function getNetValue(
  portfolioId: string,
  amount: number
): Promise<INetValue> {
  return http.get(
    `/transactions/v1/redemptions/portfolios/${portfolioId}/net-value`,
    { params: { amount } }
  );
}

export function getWithdrawSummary(
  portfolioId: string,
  amount: number,
  bankId?: string
): Promise<IWithdrawSummary> {
  return http.post('/transactions/v1/redemptions/summary', {
    portfolioId,
    amount,
    bankId
  });
}

export function sendWithdrawSuggested(
  data: ISendWithdrawSuggested
): Promise<ISendWithdrawSuggestedResponse> {
  return http.post('/investments/v1/withdraw', data);
}
